import express, { Router } from 'express';

import * as roleValidation from '@/modules/roles/roles.validation';
import * as roleController from '@/modules/roles/roles.controller';

import { validateMiddleware } from '@/shared/utils/middlewares/index';
import userAuthAndCheckPermissions from '@/modules/auth/auth.user.middleware';
import { setAuditFields } from '@/shared/middleware/setAuditFields';
import { AuditMode } from '@/shared/constants/enum.constant';
import { MODULE_LIST } from '@/shared/constants/module.constant';
import { ACTIONS } from '@/shared/constants';

const router: Router = express.Router();

router
  .route('/')
  .get(
    userAuthAndCheckPermissions(
      // MODULE_LIST.ROLE,
      // ACTIONS.READ,
    ),
    validateMiddleware(roleValidation.getRole),
    roleController.getRoles,
  )
  .post(
    userAuthAndCheckPermissions(
      MODULE_LIST.ROLE,
      ACTIONS.CREATE,
    ),
    validateMiddleware(roleValidation.createRole()),
    setAuditFields({ mode: AuditMode.CREATE }),
    roleController.createRole,
  );

router
  .route('/:id')
  .get(
    userAuthAndCheckPermissions(
      // MODULE_LIST.ROLE,
      // ACTIONS.READ,
    ),
    validateMiddleware(roleValidation.getRoleById),
    roleController.getRoleById,
  )
  .patch(
    userAuthAndCheckPermissions(
      MODULE_LIST.ROLE,
      ACTIONS.UPDATE,
    ),
    validateMiddleware(roleValidation.updateRole()),
    setAuditFields({ mode: AuditMode.UPDATE }),
    roleController.updateRole,
  )
  .delete(
    userAuthAndCheckPermissions(
      MODULE_LIST.ROLE,
      ACTIONS.DELETE,
    ),
    validateMiddleware(roleValidation.deleteRoleById),
    roleController.deleteRoleById,
  );

export default router;
